import { FormFields, SetBuyerPrefill } from '@core/data-access/models/form/form-store.model';
import { Person } from '@core/data-access/models/person.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SetSelectedSavedBillingAddress } from '../models/buyer-information-store.model';

export const BuyerInformationActions = createActionGroup({
  source: 'Buyer information',
  events: {
    'Set buyer person': (person: Person) => ({ person }),
    'Remove buyer person': emptyProps(),
    'Reset reducer': emptyProps()
  }
});

export const BuyerInformationFormActions = createActionGroup({
  source: 'Buyer information form',
  events: {
    'Set buyer information prefill and form fields': props<SetBuyerPrefill>()
  }
});

export const BuyerBillingAddressFormActions = createActionGroup({
  source: 'Buyer billing address form',
  events: {
    'Set selected saved billing address id': (selectedSavedBillingAddressId: number) => ({
      selectedSavedBillingAddressId
    }),
    'Set selected saved billing address id and form fields': (
      selectedSavedBillingAddress: SetSelectedSavedBillingAddress
    ) => ({
      selectedSavedBillingAddress
    })
  }
});

export const BuyerPrivacyPolicyFormActions = createActionGroup({
  source: 'Buyer privacy policy form',
  events: {
    'Set privacy policy checkbox': (formFields: FormFields) => ({ formFields })
  }
});
